export default __webpack_public_path__ + "static/media/pendings.d35b885d.svg";